type InstitutionBranding = {
  config?: { isBrandingHidden?: boolean | null } | null
  partner?: { config?: { isBrandingHidden?: boolean | null } | null } | null
}

/**
 * Whether the FaceUp branding should be hidden, resolved across the institution's
 * own config and its partner's (white-label) config. The institution's explicit
 * decision wins (true or false); a null/undecided flag inherits the partner's,
 * defaulting to shown.
 */
export const resolveIsBrandingHidden = (institution: InstitutionBranding): boolean =>
  institution.config?.isBrandingHidden ?? institution.partner?.config?.isBrandingHidden ?? false
